module.exports = __webpack_public_path__ + "img/upgrade3.53985223.png";